<template>
	<div class="zzgk">
		<div class="zzgk_left">
			<EditDw ref="dialogFormVisible" :dialogFormVisible="dialogFormVisible" @closeEdit="dialogFormVisible = false"></EditDw>
			<Organization ref="dialogFormVisible" :dialogFormVisible="showOrganization" @closeEdit="showOrganization = false"></Organization>
			<div class="schoolbanner">
				<div class="zbpic"></div>
				<div class="zb">
					<div class="zbname">
						<div class="lefts">
							<p>{{$store.state.user.userinfo.dw}}</p>
							<!-- <p class="icon"></p> -->
						</div>
						<div>
							<span @click="showOrganization = true" >组织架构</span>
						<span @click="dialogFormVisible = true" v-if="$store.state.user.userinfo.flag == 1">编辑信息</span>
						</div>
					</div>
					<div class="zb_control">
						<div class="zbphone">负责人：{{$store.state.user.userinfo.head_name}}</div>
						<div class="zbedit">联系电话：{{$store.state.user.userinfo.head_phone}}</div>
					</div>
				</div>
			</div>
			<div class="zzqk">
				<div class="title">组织概况</div>
				<div class="zzqk_box">
					<div>
						<p><span>{{oragen.organ_count}}</span><span>个</span></p>
						<p>组织数量</p>
					</div>
					<div>
						<p><span>{{oragen.all_count}}</span><span>名</span></p>
						<p>组织人数</p>
					</div>
					<div>
						<p><span>{{oragen.formal_count}}</span><span>名</span></p>
						<p>党员数量</p>
					</div>
					<div>
						<p><span>{{oragen.dev_count}}</span><span>名</span></p>
						<p>预备党员</p>
					</div>
					<div>
						<p><span>{{oragen.positive_count}}</span><span>名</span></p>
						<p>积极分子</p>
					</div>
				</div>
			</div>
			<div class="zzqk">
				<div class="title">活动数据</div>
				<div class="zzqk_box">
					<div>
						<p><span>{{oragen.activity_year_count}}</span><span>次</span></p>
						<p>年度活动</p>
					</div>
					<div>
						<p><span>{{oragen.study_year_count}}</span><span>次</span></p>
						<p>年度学习</p>
					</div>
					<div>
						<p><span>{{oragen.activity_month_count}}</span><span>次</span></p>
						<p>本月活动</p>
					</div>
					<div>
						<p><span>{{oragen.study_month_count}}</span><span>次</span></p>
						<p>本月学习</p>
					</div>
				</div>
			</div>
			<div class="zzqk">
				<div class="tabs">
					<div class="items">
						<div class="tabs_item" :class="{select_item:rank==2}" 
						@click="rankByMonth">本月排名</div>
						<div class="tabs_item" :class="{select_item:rank==1}" 
						@click="rankByYear">年度排名</div>
					</div>
					<div class="items">
						<div class="tabs_num" :class="{select_num:type==1}" @click="type=1">次数<i class="el-icon-sort"></i></div>
						<div class="tabs_num" :class="{select_num:type==2}" @click="type=2">课时<i class="el-icon-sort"></i></div>
					</div>
				</div>
				<div class="table">
					<el-table
						:header-cell-style="{background:'#f5f7fa',color:'#000'}"
						:data="type==1?oragen.focus_study_rank:oragen.focus_study_hour"
						stripe
						border
						style="width: 100%">
						<el-table-column 
							width="50"
							align="center"
							type="index"
							label="排名" >
						</el-table-column>
						<el-table-column
							label="组织名称">
							<template slot-scope="scope">
								{{scope.row.dw}}	
							</template>		
						</el-table-column>
						<el-table-column
							prop="count"
							label="集中学习次数"
							align="center"
							width="130">
						</el-table-column>
						<el-table-column
							prop="hour"
							label="集中学习课时"
							align="center"
							width="130">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<div class="zzgk_right">
			<div class="messbox">
				<div class="messbox_title">
					<span>
						<span>
							<img src="@/assets/images/mess.png" >
						</span>
						待办活动
					</span>
					<span @click="$router.push('/shyk')">更多</span>
				</div>
				<div class="messbox_list">
					<div class="mess_item1" :key="index" v-if="infoActivity.length > 0&&index<4" v-for="(item,index) in infoActivity" @click="godetail(item)">
						<p>{{item.title}}</p>
						<p>查看</p>
					</div>
					<div class="nomess" v-if="infoActivity.length == 0">
						<img src="@/assets/images/notodo.png" >
					</div>
				</div>
			</div>
			<div class="messbox">
				<div class="messbox_title">
					<span>
						<span>
							<img src="@/assets/images/mess.png" >
						</span>
						三会一课
					</span>
					<div style="display:flex;align-items:center">
						<span class="input_label" style="font-size:14px;font-weight:400">月份</span>
						<el-select clearable 
						size="mini"
						style="width:100px !important"
						v-model="searchData.month2" placeholder="请选择" @change="getdata()">
							<el-option
								:key="index"
								v-for="(item,index) in $monthList()"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="messbox_list">
					<div class="charts_item" :key="index" v-if="index<4"  v-for="(item,index) in activity">
						<span class="name">{{item.name}}</span>
						<div class="progress" :style="max==0?{'background':'rgba(0,0,0,0.05)'}:''">
							<span v-if="max!=0" :style="{width:(((parseInt(item.value)/max))*100)+'%'}"></span>
						</div>
						<span class="number">{{item.value}}</span>
					</div>
				</div>
			</div>
			<div class="messbox">
				<div class="messbox_title">
					<span>
						<span>
							<img src="@/assets/images/mess.png" >
						</span>
						活动趋势
					</span>
					<div style="display:flex;align-items:center">
						<span class="input_label" style="font-size:14px;font-weight:400">年份</span>
						<el-select clearable 
						size="mini"
						style="width:100px !important"
						v-model="searchData.year2" placeholder="请选择" @change="getdata()">
							<el-option
								:key="index"
								v-for="(item,index) in $yearList()"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="messbox_list">
					<div class="jzxxbox">
						<LineChart 
							id="jzxx"
							height="100%"
							width="100%"
							:max ='maxActive'
							:min ='0'
							:lingdata='lingdata'>
						</LineChart>
					</div>
					<div class="legend">
						<div class="legend1">集中学习<span></span></div>
						<div>组织活动<span></span></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import LineChart from '@/components/charts/lineChart.vue'
	import { zzgk } from '@/axios/index'
	import EditDw from './components/editdw.vue'
	import Organization from './components/Organization.vue'
	let that;
	export default{
		data(){
			return{
				seletYear:new Date().getFullYear(),
				seletMonth:(new Date().getMonth()+1)<10?('0'+(new Date().getMonth()+1)):(new Date().getMonth()+1),
				lingdata:{},
				searchData:{
					dwid:this.$store.state.user.userinfo.dwid,
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					year:new Date().getFullYear(),
					year2:new Date().getFullYear(),
					month:(new Date().getMonth()+1)<10?('0'+(new Date().getMonth()+1)):(new Date().getMonth()+1),
					month2:(new Date().getMonth()+1)<10?('0'+(new Date().getMonth()+1)):(new Date().getMonth()+1)
				},
				time:"",
				oragen:{},
				messList:[],
				infoActivity:[],
				dialogFormVisible:false,
				activity:[],//三会一课
				max:0,//三会一课最大值
				tableData:[],
				type:1, //1:次数  2:时长
				rank:2,//1:年度2：月度
				maxActive:0,//活动图表最大值,
				// 组织架构
				showOrganization:false
			}
		},
		components:{
			LineChart,
			EditDw,
			Organization
		},
		methods:{
			// 年度排名
			rankByYear(){
				that.rank = 1;
				that.searchData.year = new Date().getFullYear();
				that.searchData.month = "";
				that.getdata();
			},
			rankByMonth(){
				that.rank = 2;
				that.searchData.month = (new Date().getMonth()+1)<10?('0'+(new Date().getMonth()+1)):(new Date().getMonth()+1);
				that.getdata();
			},
			// 请求数据
			getdata(){
				zzgk.zzgkData(that.searchData).then(res => {
					// 统计图
					setTimeout(function(){
						let arr=[],arr1=[],max1=0,max2=0;
						that.lingdata = {
							studyData:res.data.hyLog,
							activData:res.data.focus
						}
						res.data.hyLog.map(item => {
							arr.push(parseInt(item))
						})
						res.data.focus.map(item => {
							arr1.push(parseInt(item))
						})
						max1 = Math.max(...arr);
						max2 = Math.max(...arr);
						console.log(max1)
						console.log(max2)
						that.maxActive = max1>max2?max1:max2
					},300)
					// 三会一课
					let arr = []
					that.activity = res.data.activity;
					that.activity.map(item => {
						arr.push(parseInt(item.value))
					})
					that.max = Math.max(...arr)
					// 消息
					if(res.data.message.length > 0 || res.data.message != null){
						that.messList = res.data.message
					}else{
						that.messList = []
					}
					// 待办
					if(res.data.infoActivity.length > 0 || res.data.infoActivity != null){
						that.infoActivity = res.data.infoActivity
					}else{
						that.infoActivity = []
					}
					// 组织数量及人数
					that.oragen = res.data
				})
			},
			// 消息详情
			godetail(data){
				if(data.classs == 2){
					that.$router.push({
						path:'/gzhb_detail',
						query:{
							id:data.tid,
							zbid:data.zbid,
							flag:data.flag,
						}
					})
				}else if(data.classs == 1){
					that.$router.push({
						path:'/fbtz_detail',
						query:{
							id:data.tid
						}
					})
				}else{
					that.$router.push({
						path:"/zzhd_detaill",
						query:{
							hy_flag:data.hy_flag,
							hyid:data.hyid,
							dw:that.getdata.pub_user,
							uid:that.getdata.zbid,
						}
					})
				}
			}
		},
		mounted() {
			that.getdata()
		},
		created() {
			that = this;
			that.$emit('selectTop',1)
		}
	}
</script>
<style lang="scss">
	@import './index.scss';
</style>